import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-login-unico-test',
  templateUrl: './login-unico-test.component.html',
  styleUrls: ['./login-unico-test.component.css']
})
export class LoginUnicoTestComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
